import axios from "axios";
import { requiredParam } from "@utils/func";

const getTodos = () => {
  return axios.get("todolist");
};

export { getTodos };
